import axios from 'axios';
import store from '../store/store';
import MainService from './MainService';

export default class ServiceOrderService extends MainService {
	constructor() {
		super();
		this.url = `${this.apiUrl}/guide-service-orders`;
	}

	filter(filter) {
		return axios.get(this.url+'/filter', {params: filter});
	}

  fetchChanges(id) {
		return axios.get(`${this.url}/changes/${id}`);
	}

  getGuideAccountability(id) {
		return axios.get(`${this.url}/${id}/guide-accountability/${store.state.user.id}`);
  }
}



// WEBPACK FOOTER //
// ./src/service/ServiceOrderService.js